module.exports = __webpack_public_path__ + "static/logo_tq-227629f0332220587ab206981e851050.png";